import { Box, Flex } from '@oplog/express';
import lottie from 'lottie-web/build/player/lottie_light';
import React, { useCallback, useEffect, useRef } from 'react';
import BarcodeIcon, { StatusEnum } from './BarcodeIcon';

export interface IScanStatusBox {
  status: StatusEnum;
  children?: React.ReactNode;
}

const ScanStatusBox: React.FC<IScanStatusBox> = ({ children, status }) => {
  const lottieContainer = useRef<any>(null);

  useEffect(() => {
    lottie.loadAnimation({
      container: lottieContainer.current,
      renderer: 'svg',
      loop: true,
      autoplay: true,
      animationData: require('../../../../lotties/loadingAnimation.json'),
    });
  }, [status]);

  const selectBoxShadow = useCallback(
    (arg: StatusEnum) => {
      switch (arg) {
        case StatusEnum.Success:
          return '0 0 20px #39d98a';
        case StatusEnum.Cancelled:
          return '0 0 20px #ff5c5c';
        case StatusEnum.WrongBarcode:
          return '0 0 20px #ff5c5c';
        case StatusEnum.ShipmentFailure:
          return '0 0 20px #fdac42';
        default:
          return 'none';
      }
    },
    [status]
  );

  return (
    <Flex
      height="65vh"
      width={1}
      px={30}
      py={16}
      borderRadius="lg"
      bg="palette.softGrey"
      justifyContent="space-evenly"
      alignItems="center"
      flexDirection="column"
      transition="0.5s ease"
      boxShadow={selectBoxShadow(status)}
    >
      {status === StatusEnum.Loading ? (
        <Box ref={lottieContainer} width={88} height={88} data-testid="lottieAnimation" />
      ) : (
        <BarcodeIcon status={status} />
      )}
      {children}
    </Flex>
  );
};

export default ScanStatusBox;
